import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@material-ui/core";
import { AppState } from "../../../redux/reducers/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import { uiCloseModalNull } from "../../../redux/actions/uiActions";
import { FormattedMessage, useIntl } from "react-intl";
import clsx from "clsx";
import { useStyles } from "../../../shared/styles/useStyles";
import {
  setActiveCorrespondence,
  startDeleteCorrespondece,
} from "../../../redux/actions/correspondenceActions";
import { useEffect, useRef, useState } from "react";
import { CorrespondenceInputType } from "../../../enums/enums";
import moment from "moment";

export const CorrespondenceNull = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const fileAct = useRef<HTMLInputElement>(null);
  const [error, setError] = useState<boolean>(false);
  const intl = useIntl();

  //load storage info
  const { activeCorrespondence } = useSelector(
    (state: AppState) => state.correspondence
  );

  const onClose = () => {
    dispatch(uiCloseModalNull());
    dispatch(setActiveCorrespondence(null));
  };

  const NullCorrespondence = () => {
    const file = fileAct.current;
    if (file && file.files && file.files.length > 0) {
      dispatch(startDeleteCorrespondece(file.files));
    } else {
      setError(true);
    }
  };

  useEffect(() => {}, []);

  return (
    <Box m={1} display={"flex"} flexDirection="column">
      <Table
        className={classes.table}
        size="small"
        style={{ tableLayout: "auto" }}
        aria-label="a dense table"
      >
        <TableHead>
          <TableRow>
            <TableCell
              width={"15%"}
              align="center"
              className={classes.titleTable}
            >
              ID
            </TableCell>
            <TableCell align="center" className={classes.titleTable}>
              <FormattedMessage id="InputType" />
            </TableCell>
            <TableCell align="center" className={classes.titleTable}>
              <FormattedMessage id="CommunicationType" />
            </TableCell>
            <TableCell align="center" className={classes.titleTable}>
              <FormattedMessage id="Subject" />
            </TableCell>
            <TableCell align="center" className={classes.titleTable}>
              <FormattedMessage id="Date" />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell align="center">{activeCorrespondence?.id}</TableCell>
            <TableCell align="center">
              {(() => {
                switch (activeCorrespondence?.inputType) {
                  case CorrespondenceInputType.EP:
                    return <FormattedMessage id="ExternalProduced" />;
                  case CorrespondenceInputType.ER:
                    return <FormattedMessage id="ExternalReceived" />;
                  case CorrespondenceInputType.IR:
                    return <FormattedMessage id="InternalReceived" />;
                  case CorrespondenceInputType.IP:
                    return <FormattedMessage id="InternalProduced" />;
                  case CorrespondenceInputType.OR:
                    return <FormattedMessage id="OtherShipmentsReceived" />;
                  case CorrespondenceInputType.OP:
                    return <FormattedMessage id="OtherShipmentsProduced" />;
                  default:
                    return null;
                }
              })()}
            </TableCell>

            <TableCell align="center">
              {intl.formatMessage({
                id: `${activeCorrespondence?.communicationType?.option}`,
              })}
            </TableCell>
            <TableCell align="center">
              {activeCorrespondence?.subject}
            </TableCell>
            <TableCell align="center">
              {" "}
              {moment(activeCorrespondence?.createAt.toDate()).format(
                "YYYY/MM/DD"
              )}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <br></br>
      <Box style={{ textAlign: "center", display: "block" }}>
        <TextField
          id="file-act"
          name="file-act"
          type="file"
          label={""}
          color="secondary"
          variant="outlined"
          inputRef={fileAct}
          error={error}
          helperText={error ? "Debe adjuntar un Acta " : ""}
        />
      </Box>

      <Box mt={2} style={{ textAlign: "center", display: "block" }}>
        <Button
          className={clsx(classes.btn, classes.save)}
          onClick={NullCorrespondence}
        >
          <FormattedMessage id="annulled.name" />
        </Button>
        <Button className={clsx(classes.btn, classes.cancel)} onClick={onClose}>
          <FormattedMessage id="Cancel" />
        </Button>
      </Box>
    </Box>
  );
};
